import { render, staticRenderFns } from "./ExternRegistrationActionCell.vue?vue&type=template&id=2d3e8ba0&scoped=true&"
import script from "./ExternRegistrationActionCell.vue?vue&type=script&lang=js&"
export * from "./ExternRegistrationActionCell.vue?vue&type=script&lang=js&"
import style0 from "./ExternRegistrationActionCell.vue?vue&type=style&index=0&id=2d3e8ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e8ba0",
  null
  
)

export default component.exports